var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3197 17.975C8.93153 17.5841 8.93225 16.9524 9.3218 16.5629L12.4909 13.3938C12.8811 13.0036 12.8814 12.371 12.4916 11.9804L9.32103 8.80288C8.93219 8.41319 8.93253 7.78216 9.3218 7.39288V7.39288C9.71138 7.00331 10.343 7.00331 10.7326 7.39288L15.3201 11.9804C15.7106 12.3709 15.7106 13.0041 15.3201 13.3946L10.7368 17.9779C10.3453 18.3694 9.70981 18.3679 9.3197 17.975V17.975Z",
    fill: "#7C63A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.c6ae132819ebbfb30e908855ed8b6e01.svg";
export { ForwardRef as ReactComponent };